import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileAlcoholSubSection extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private datePickerRef: DateSelector;

    public render(): JSX.Element {
        const model = this.props.form.Section9.Alcohol;

        return (
            <tbody>
                <tr>
                    <td className="bold">{this.getString("AlcoholLabel")}</td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.DrankAlcoholThreeMonthsBeforePregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Alcohol.DrankAlcoholThreeMonthsBeforePregnancy = value),
                            "Section9_DrankAlcoholThreeMonthsBeforePregnancy"
                        )}
                    </td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.DrinksAlcoholDuringPregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Alcohol.DrinksAlcoholDuringPregnancy = value),
                            "Section9_DrinksAlcoholDuringPregnancy"
                        )}
                    </td>
                </tr>
                <tr>
                    <td>{this.getString("ObstetricalFile_NumberDrinksPerWeekLabel")}</td>
                    <td>
                        {this.controlRenderer.renderTextbox({
                            value: model?.DrinksPerWeekThreeMonthsBeforePregnancy?.toString() ?? "",
                            onChange: value => this.props.mutateModelState(
                                s => {
                                    s.Section9.Alcohol.DrinksPerWeekThreeMonthsBeforePregnancy = value;
                                    if (!!s.Section9.Alcohol.DrinksPerWeekThreeMonthsBeforePregnancy)
                                        s.Section9.Alcohol.DrankAlcoholThreeMonthsBeforePregnancy ??= true;
                                }
                            ),
                            maxLength: this.page1FieldLimits.SubstanceUse_3MonthsBeforePregnancy_DrinksPerWeek.MaxChars
                        })}
                    </td>
                    <td>
                        {this.controlRenderer.renderTextbox({
                            value: model?.DrinksPerWeekDuringPregnancy?.toString() ?? "",
                            onChange: value => this.props.mutateModelState(
                                s => {
                                    s.Section9.Alcohol.DrinksPerWeekDuringPregnancy = value;
                                    if (!!s.Section9.Alcohol.DrinksPerWeekDuringPregnancy)
                                        s.Section9.Alcohol.DrinksAlcoholDuringPregnancy ??= true;
                                }
                            ),
                            maxLength: this.page1FieldLimits.SubstanceUse_DuringPregnancy_DrinksPerWeek.MaxChars
                        })}
                    </td>
                </tr>
                <tr>
                    <td>{this.getString("ObstetricalFile_GreaterOrEqual4DrinksAtOneTimeLabel")}</td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.GreaterOrEqualFourDrinksAtOneTimeThreeMonthsBeforePregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Alcohol.GreaterOrEqualFourDrinksAtOneTimeThreeMonthsBeforePregnancy = value),
                            "Section9_GreaterOrEqualFourDrinksAtOneTimeThreeMonthsBeforePregnancy"
                        )}
                    </td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.GreaterOrEqualFourDrinksAtOneTimeDuringPregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Alcohol.GreaterOrEqualFourDrinksAtOneTimeDuringPregnancy = value),
                            "Section9_GreaterOrEqualFourDrinksAtOneTimeDuringPregnancy"
                        )}
                    </td>
                </tr>
                <tr>
                    <td colSpan={3}>
                        <div className="nowrap">
                            <span>{this.getString("QuitAlcoholLabel")}:</span>
                            <span className="margin-sm-left">
                                {this.renderInlineNoYesRadio(
                                    model?.HasQuitAlcohol,
                                    value => this.props.mutateModelState(
                                        s => s.Section9.Alcohol.HasQuitAlcohol = value,
                                        () => model?.HasQuitAlcohol && this.datePickerRef.open()
                                    ),
                                    "Section9_HasQuitAlcohol"
                                )}
                            </span>
                            <span className="margin-md-left section9-date-container">
                                {this.renderInlineDatePicker(
                                    "DateLabel",
                                    model?.QuitAlcoholDate,
                                    value => this.props.mutateModelStateWithFormUpdate(
                                        s => {
                                            s.Section9.Alcohol.QuitAlcoholDate = value;
                                            s.Section9.Alcohol.HasQuitAlcohol ??= !!value;
                                        }
                                    ),
                                    "",
                                    "normal-text",
                                    ref => this.datePickerRef = ref
                                )}
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    private renderInlineNoYesRadio(value: boolean, onChange: (value: boolean) => void, id: string): JSX.Element {
        return this.controlRenderer.renderInlineYesNoRadio(value, onChange, id, "resizable", null, true);
    }
}

export { BritishColumbiaObstetricalFileAlcoholSubSection };
